export default "__VITE_ASSET__CBNKE3Lw__"